import { useSyncExternalStore } from 'react'
import { removeSavedTest, savedTestsSnapshot, subscribeSavedTests, type SavedTest } from '../lib/savedTests'

export interface UseSavedTests {
    tests: SavedTest[]
    remove: (id: string) => void
}

/** Reads the saved-test list and re-renders when any part of the app writes it. */
export function useSavedTests(): UseSavedTests {
    const tests = useSyncExternalStore(subscribeSavedTests, savedTestsSnapshot, savedTestsSnapshot)
    return { tests, remove: removeSavedTest }
}
